import MdDialogAlert from "./MdDialogAlert"

const MdDialogAlertPlugin = {
  install(app) {
    app.component(MdDialogAlert.name, MdDialogAlert)
  },
}

export default MdDialogAlertPlugin
